import React from 'react';
import * as S from './RequiredStar.styles';

export const RequiredStar = () => {
  return (
    <S.RequiredStarBox as="span" data-testid="required-star">
      *
    </S.RequiredStarBox>
  );
};
